import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';

/**
 * Stat / KPI card with prominent icon, label, value, and optional accent color.
 * Designed to pair with the blue gradient hero header.
 */
const StatCard = ({ label, value, icon, helper, accent = '#3B82F6' }) => (
  <Paper
    elevation={0}
    sx={{
      p: 2,
      borderRadius: 2,
      border: '1px solid',
      borderColor: 'rgba(15, 23, 42, 0.12)',
      height: '100%',
      bgcolor: '#ffffff',
      boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.06)',
      transition: 'transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease',
      cursor: 'default',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 10px 24px rgba(15, 23, 42, 0.1)',
        borderColor: 'rgba(59, 130, 246, 0.4)'
      }
    }}
  >
    <Stack direction="row" spacing={1.25} alignItems="flex-start">
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 1.5,
          bgcolor: `${accent}14`,
          color: accent,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          '& svg': { color: accent, fontSize: 20 }
        }}
      >
        {icon}
      </Box>
      <Box sx={{ minWidth: 0, width: '100%' }}>
        <Typography
          variant="caption"
          sx={{
            color: '#64748B',
            fontWeight: 600,
            letterSpacing: 0.4,
            textTransform: 'uppercase',
            fontSize: '0.65rem',
            lineHeight: 1.2
          }}
        >
          {label}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 700,
            color: '#0f172a',
            lineHeight: 1.3,
            mt: 0.4,
            overflowWrap: 'anywhere',
            fontSize: '0.95rem'
          }}
        >
          {value}
        </Typography>
        {helper && (
          <Typography
            variant="caption"
            sx={{ color: '#94A3B8', mt: 0.2, display: 'block' }}
          >
            {helper}
          </Typography>
        )}
      </Box>
    </Stack>
  </Paper>
);

export default StatCard;
